// Consentimiento Habeas Data y atribucion de marketing para los formularios publicos.
// El texto y el enlace de la politica se parametrizan en el backend (GET /api/data-policy/).
import { useEffect, useState } from "react";

const API_URL = process.env.REACT_APP_API_URL || "https://ecf.back.ejecomercial.co/api";
const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
const UTM_STORAGE_KEY = "ecf_utm";

export const FALLBACK_CONSENT =
  "Acepto de manera expresa y voluntaria la política de tratamiento de datos personales (Ley 1581 de 2012) para fines de estudio de crédito y contacto comercial.";

export interface DataPolicy {
  required: boolean;
  policy_url: string;
  policy_version: string;
  consent_text: string;
}

export function useDataPolicy(): DataPolicy | null {
  const [policy, setPolicy] = useState<DataPolicy | null>(null);
  useEffect(() => {
    fetch(`${API_URL}/data-policy/`)
      .then(res => (res.ok ? res.json() : null))
      .then(setPolicy)
      .catch(() => setPolicy(null));
  }, []);
  return policy;
}

export function captureAttribution(): void {
  const params = new URLSearchParams(window.location.search);
  const found: Record<string, string> = {};
  UTM_KEYS.forEach(key => {
    const value = (params.get(key) || "").trim();
    if (value) found[key] = value.slice(0, 150);
  });
  if (Object.keys(found).length === 0) return;
  try {
    sessionStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(found));
  } catch {
    // Sin almacenamiento los UTM se pierden si el visitante navega antes de enviar.
  }
}

export function getAttribution(): Record<string, string> {
  let stored: Record<string, string> = {};
  try {
    stored = JSON.parse(sessionStorage.getItem(UTM_STORAGE_KEY) || "{}");
  } catch {
    stored = {};
  }
  return { ...stored, landing: "corporativa" };
}
